import { Icon } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function WebhookScreen() {
	return (
		<>
			<div
				style={{
					textAlign: 'center',
					alignContent: 'center',
				}}
			>
				<Icon type="frown" style={{ fontSize: 40 }} theme="twoTone" />
				<br />
				<br />
				<FormattedMessage id="not_done_yet" />
				<br />
				<br />
				<FormattedMessage id="not_done_yet2" />
				<br />
				<br />
				<FormattedMessage id="not_done_yet3" />
				<br />
			</div>
		</>
	);
}
